import { NavigateFunction } from 'react-router-dom'
import { Nullable, Theme } from '@infologistics/frontend-libraries';

export interface IBasicNotificationOptions {
  content: string
  isTimerShow?: boolean
  title: string
  type: string
}

export interface ISuccessNotificationOptions {
  content?: string
  title?: string
}

export interface IConfirmNotificationOptions {
  cancelText?: string
  content?: string
  contentNotification?: string
  submitText?: string
  onSubmit: () => any
  title?: string
  theme?: Theme
}

export interface ITo {
  navigate: NavigateFunction
  section: string
}

export interface IName {
  lastName?: Nullable<string>
  firstName?: Nullable<string>
  middleName?: Nullable<string>
  language: string
}

/** Свойства файла  */
export type IFileProperties = {
  size: number;
  mimeType: string;
};

/** MassiveActionsDropdown: доступные действия */
export enum AllowedAction {
  RESEND = 'RESEND',
  DELETE = 'DELETE',
}

/** MassiveActionsDropdown: интерфейс доступных действий */
export type IAllowedAction =
  | AllowedAction.RESEND
  | AllowedAction.DELETE
